import InputGenerator from './InputGenerator';

export default InputGenerator('v2');
